import * as React from 'react';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import './TournamentBookingSuccessModal.scss';

interface Props {
  isOpen: boolean;
  tournamentName?: string;
  onClose: () => void;
}

export const TournamentBookingSuccessModal: React.FC<Props> = ({ isOpen, tournamentName, onClose }) => (
  <SimpleModal
    isOpen={isOpen}
    showHeader={false}
    bodyClassName="tournamentBookingSuccessHost"
    dialogStyle={{ maxWidth: 560 }}
  >
    <div className="tournamentBookingSuccess">
      <header className="tournamentBookingSuccess__head">
        <span className="tournamentBookingSuccess__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="m6.5 12.5 3.5 3.5 7.5-8" />
          </svg>
        </span>
        <div>
          <h2>Tournament booked</h2>
          <p>Your school's place has been confirmed.</p>
        </div>
        <button type="button" className="tournamentBookingSuccess__close" onClick={onClose} aria-label="Close">
          <span>&times;</span>
        </button>
      </header>

      <div className="tournamentBookingSuccess__body">
        <p className="tournamentBookingSuccess__message">
          Your school has been registered as a participant in {tournamentName || 'this tournament'}.
        </p>
        <section className="tournamentBookingSuccess__next">
          <h3>What happens next</h3>
          <ul>
            <li>You can view and manage this tournament from your upcoming tournaments.</li>
            <li>
              You will receive a notification from the organisers once you are able to add your athletes to the
              individual events.
            </li>
          </ul>
        </section>
      </div>

      <footer className="tournamentBookingSuccess__foot">
        <button type="button" onClick={onClose}>
          View upcoming tournaments
        </button>
      </footer>
    </div>
  </SimpleModal>
);

TournamentBookingSuccessModal.displayName = 'TournamentBookingSuccessModal';
